import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import PracticeIcon from "@mui/icons-material/LocalHospital";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { emphasize, useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import constants from "../../assets/constants";
import { createNewPractice } from "../../data/omniDataModel";
import * as AdminActions from "../../state/redux/adminSession";
import * as PracticeActions from "../../state/redux/practiceSession";
import PracticeDialog from "../dialogs/practiceDialog";
import OmniResponsiveButton from "../ui/omniResponsiveButton.js";
import Widget from "../ui/widget";
import WidgetList from "../ui/widgetList";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetTitle from "../ui/widgetTitle";

const SelectPractice = props => {
  const { allPractices, loadPracticesRequest } = props;

  const [newPractice, setNewPractice] = useState(null);

  useEffect(() => {
    if (allPractices == null) {
      loadPracticesRequest();
    }
  }, [allPractices, loadPracticesRequest]);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (allPractices != null) {
      setTitleText(
        `${allPractices.length} ${allPractices.length === 1 ? "Practice" : "Practices"}`,
      );
    } else setTitleText("");
  }, [allPractices]);

  const theme = useTheme();

  return (
    <Widget>
      <WidgetTitle title={"Select"} text={titleText} loading={allPractices == null}>
        <OmniResponsiveButton
          tooltipTitle="Create a new practice"
          buttonText="Practice"
          onClick={() => {
            setNewPractice(createNewPractice);
          }}
        />
      </WidgetTitle>

      {allPractices == null && <WidgetSkeleton />}
      {allPractices != null && allPractices.length === 0 && (
        <WidgetList>
          <Typography variant="h5">{"No Practices Found"}</Typography>
        </WidgetList>
      )}

      {allPractices != null && allPractices.length > 0 && (
        <WidgetList>
          {allPractices
            .sort((a, b) => a.omniData.name.localeCompare(b.omniData.name))
            .map((practice, index) => {
              return (
                <ListItem
                  key={`practice${index}`}
                  disableGutters={true}
                  sx={{
                    padding: theme.spacing(1),
                    paddingTop: 0,
                    paddingBottom: 0,
                    marginBottom: theme.spacing(1),
                    borderRadius: theme.spacing(1),
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.secondary.contrastText,
                    boxShadow: theme.shadows[3],
                    "&:hover": {
                      backgroundColor: emphasize(theme.palette.secondary.main, 0.25),
                      cursor: "pointer",
                    },
                  }}
                  onClick={e => {
                    e.stopPropagation();
                    props.setPracticeODMRequest(practice);
                    props.history.push(constants.appPaths.appPathPractices);
                  }}
                >
                  <ListItemText
                    primary={<Typography variant="h6">{`${practice.omniData.name}`}</Typography>}
                    secondary={
                      <Typography variant="body2">{"No Additional Information"}</Typography>
                    }
                  />
                  <PracticeIcon
                    sx={{
                      fontSize: "2.5em",
                    }}
                  />
                </ListItem>
              );
            })}
        </WidgetList>
      )}

      {newPractice != null && (
        <PracticeDialog
          open={newPractice != null}
          dialogTitle={`${newPractice._id == null ? "Add" : "Edit"} Practice`}
          omniDMO={newPractice}
          fullWidth={true}
          onDelete={() => {
            setNewPractice(null);
          }}
          onAccept={newPractice => {
            props.updatePracticeRequest(newPractice);
            setNewPractice(null);
          }}
          onClose={() => {
            setNewPractice(null);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  allPractices: state.adminSession.practiceODMs,
});

const mapDispatchToProps = {
  loadPracticesRequest: AdminActions.loadPracticesRequest,
  updatePracticeRequest: PracticeActions.updatePracticeRequest,
  setPracticeODMRequest: PracticeActions.setPracticeODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectPractice));
